import { computed } from 'vue';
import { useRoute } from 'vue-router';

export const SALON_PHOTO_2026_CODE = 'PHOTO2026';
// Dates incluses, en heure de Paris
const START_DAY = '2026-10-08';
const END_DAY = '2026-10-18';

// Jour courant à Paris au format YYYY-MM-DD (sv-SE formate en ISO)
function parisDay(): string {
    return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Paris' }).format(new Date());
}

// ?preview_promo=salon2026 permet de vérifier l'affichage avant le lancement
export function useSalonPhoto2026Active() {
    const route = useRoute();
    return computed(() => {
        if (route.query.preview_promo === 'salon2026') {
            return true;
        }
        const today = parisDay();
        return today >= START_DAY && today <= END_DAY;
    });
}
